(function () {
  'use strict';

  function esc(str) {
    var d = document.createElement('div');
    d.appendChild(document.createTextNode(String(str || '')));
    return d.innerHTML;
  }

  function ProductCompare(el) {
    this.el = el;
    this.id = el.dataset.sectionId;
    this.cfg = window.pcData && window.pcData[this.id];
    if (!this.cfg) return;

    this.selected = new Map();
    this.grid = el.querySelector('.pc-grid');

    // Main product (when includeMainProduct setting is on)
    this.mainProduct = null;
    this.mainProductCard = null;
    if (this.cfg.includeMainProduct && this.cfg.mainProduct && this.cfg.mainProduct.pid) {
      var mp = this.cfg.mainProduct;
      var mpAttrs = [];
      for (var i = 1; i <= 10; i++) { mpAttrs.push(mp['attr' + i] || ''); }
      this.mainProductCard = el.querySelector('.pc-card--main');
      var mpReviewTpl = this.mainProductCard && this.mainProductCard.querySelector('.pc-review-tpl');
      var mpReviewHtml = '';
      if (mpReviewTpl && mpReviewTpl.content) {
        var _tmp = document.createElement('div');
        _tmp.appendChild(mpReviewTpl.content.cloneNode(true));
        mpReviewHtml = _tmp.innerHTML;
      }
      this.mainProduct = { pid: mp.pid, title: mp.title, img: mp.img, price: mp.price, url: mp.url, attrs: mpAttrs, reviewHtml: mpReviewHtml };
    }
    // Effective limits: reserve 1 slot for main product when it's auto-included
    this._effectiveMax = this.mainProduct ? Math.max(1, this.cfg.maxCompare - 1) : this.cfg.maxCompare;
    this._effectiveMin = this.mainProduct ? Math.max(1, this.cfg.minCompare - 1) : this.cfg.minCompare;

    // Selectable cards exclude the hidden main-product placeholder
    this.cards = Array.prototype.slice.call(el.querySelectorAll('.pc-card:not(.pc-card--main)'));
    this.bar = el.querySelector('.pc-bar');
    this.barThumbs = el.querySelector('.pc-bar__thumbs');
    this.barCount = el.querySelector('.pc-bar__count');
    this.barClear = el.querySelector('.pc-bar__clear');
    this.barCta = el.querySelector('.pc-bar__cta');
    this.popup = el.querySelector('.pc-popup');
    this.popupTableWrap = el.querySelector('.pc-table-wrap');
    this.popupClose = el.querySelector('.pc-popup__close');
    this.popupBackdrop = el.querySelector('.pc-popup__backdrop');
    this.sliderOuter = el.querySelector('.pc-slider-outer');
    this.prevBtn = el.querySelector('.pc-slide-btn--prev');
    this.nextBtn = el.querySelector('.pc-slide-btn--next');
    this._lastFocused = null;
    this._popupKeyHandler = null;

    this._bindCards();
    this._bindBar();
    this._bindSlider();
    this._bindPopup();
    this._initCartAjax();
    this._moveToBody();
    this._watchDrawers();
    this._autoSelectCurrentProduct();
  }

  /* ─── Card selection ─── */

  ProductCompare.prototype._bindCards = function () {
    var self = this;
    this.cards.forEach(function (card) {
      // Checkbox button click
      var btn = card.querySelector('.pc-card__select');
      if (btn) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          self._toggleCard(card);
        });
      }

      // Image link click → toggle compare (prevent navigation)
      var imgLink = card.querySelector('a.grid__image');
      if (imgLink) {
        imgLink.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          self._toggleCard(card);
        });
      }
    });
  };

  ProductCompare.prototype._toggleCard = function (card) {
    var pid = card.dataset.pid;
    if (this.selected.has(pid)) {
      this._deselect(pid, card);
    } else {
      this._select(pid, card);
    }
    this._updateBar();
  };

  ProductCompare.prototype._select = function (pid, card) {
    var attrs = [];
    for (var i = 1; i <= 10; i++) {
      attrs.push(card.getAttribute('data-attr' + i) || '');
    }
    var ratingEl = card.querySelector('.product-grid--rating');
    this.selected.set(pid, {
      pid: pid,
      title: card.dataset.title || '',
      img: card.dataset.img || '',
      price: card.dataset.price || '',
      url: card.dataset.url || '',
      attrs: attrs,
      reviewHtml: ratingEl ? ratingEl.outerHTML : ''
    });
    card.classList.add('is-selected');
    var btn = card.querySelector('.pc-card__select');
    if (btn) btn.setAttribute('aria-pressed', 'true');
  };

  ProductCompare.prototype._deselect = function (pid, card) {
    this.selected.delete(pid);
    card.classList.remove('is-selected');
    var btn = card.querySelector('.pc-card__select');
    if (btn) btn.setAttribute('aria-pressed', 'false');
  };

  ProductCompare.prototype._flashMaxReached = function () {
    var self = this;
    if (this.bar.classList.contains('is-active')) {
      var orig = this.barCount.textContent;
      this.barCount.textContent = this.cfg.maxReachedText.replace('{n}', this.cfg.maxCompare);
      setTimeout(function () {
        if (self.selected.size > 0) self.barCount.textContent = orig;
      }, 2000);
    }
  };

  /* ─── Widget z-index management ───
     When the bar is active, any fixed-position element (third-party chat /
     accessibility widget) that overlaps the bar area is pushed behind it.
     z-index values are saved and restored when the bar hides.              */
  ProductCompare.prototype._syncWidgets = function (barActive) {
    var self = this;
    var BAR_ZONE = 90; // px from bottom — anything inside this zone gets managed

    if (barActive) {
      self._managedWidgets = [];
      var vh = window.innerHeight;
      var candidates = document.querySelectorAll('body > *');
      for (var i = 0; i < candidates.length; i++) {
        var el = candidates[i];
        if (el === self.bar || el === self.popup) continue;
        var cs = window.getComputedStyle(el);
        if (cs.position !== 'fixed' && cs.position !== 'sticky') continue;
        // Skip cart drawers and theme drawers — they manage their own z-index and
        // must stay above page content (pc-card__select is z-index: 20)
        var tagLC = el.tagName.toLowerCase();
        var clsLC = (typeof el.className === 'string' ? el.className : '').toLowerCase();
        if (tagLC.indexOf('drawer') !== -1 || clsLC.indexOf('drawer') !== -1) continue;
        try {
          var rect = el.getBoundingClientRect();
          if (rect.bottom > vh - BAR_ZONE && rect.width > 0 && rect.height > 0) {
            self._managedWidgets.push({ el: el, z: el.style.zIndex });
            el.style.zIndex = '1';
          }
        } catch (e) {}
      }
    } else {
      if (self._managedWidgets) {
        self._managedWidgets.forEach(function (item) {
          item.el.style.zIndex = item.z;
        });
        self._managedWidgets = [];
      }
    }
  };

  ProductCompare.prototype._updateBar = function () {
    var self = this;
    var count = this.selected.size;
    var totalCount = count + (this.mainProduct ? 1 : 0);
    if (count === 0) {
      this.bar.classList.remove('is-active');
      this._syncWidgets(false);
      return;
    }
    var wasActive = this.bar.classList.contains('is-active');
    this.bar.classList.add('is-active');
    if (!wasActive) this._syncWidgets(true);
    var remaining = this._effectiveMin - count;
    if (remaining > 0) {
      this.barCount.textContent = this.cfg.addMoreText.replace('{n}', remaining);
      this.barCta.disabled = true;
    } else {
      this.barCount.textContent = this.cfg.selectedText.replace('{n}', totalCount);
      this.barCta.disabled = false;
    }
    this.barThumbs.innerHTML = '';
    // Main product thumb always first
    if (this.mainProduct && this.mainProduct.img) {
      var mImg = document.createElement('img');
      mImg.src = this.mainProduct.img;
      mImg.alt = this.mainProduct.title;
      mImg.className = 'pc-bar__thumb';
      mImg.width = 44; mImg.height = 44;
      this.barThumbs.appendChild(mImg);
    }
    this.selected.forEach(function (data) {
      if (data.img) {
        var img = document.createElement('img');
        img.src = data.img;
        img.alt = data.title;
        img.className = 'pc-bar__thumb';
        img.width = 44;
        img.height = 44;
        self.barThumbs.appendChild(img);
      }
    });
  };

  ProductCompare.prototype._bindBar = function () {
    var self = this;
    this.barClear.addEventListener('click', function () {
      self.selected.forEach(function (data, pid) {
        var card = self.el.querySelector('.pc-card[data-pid="' + pid + '"]');
        if (card) self._deselect(pid, card);
      });
      self.selected.clear();
      self._updateBar();
    });
    this.barCta.addEventListener('click', function () {
      if (self.selected.size >= self._effectiveMin) self._openPopup();
    });
  };

  /* ─── Slider ─── */

  ProductCompare.prototype._bindSlider = function () {
    var self = this;
    if (!this.prevBtn || !this.nextBtn) return;

    function getScrollAmt() {
      var card = self.grid.querySelector('.pc-card');
      if (!card) return 280;
      var gapStr = window.getComputedStyle(self.grid).columnGap
        || window.getComputedStyle(self.grid).gap || '0px';
      return card.offsetWidth + (parseInt(gapStr) || 0);
    }

    this.prevBtn.addEventListener('click', function () {
      self.grid.scrollBy({ left: -getScrollAmt(), behavior: 'smooth' });
    });
    this.nextBtn.addEventListener('click', function () {
      self.grid.scrollBy({ left: getScrollAmt(), behavior: 'smooth' });
    });

    function updateBtns() {
      self.prevBtn.disabled = self.grid.scrollLeft <= 1;
      self.nextBtn.disabled =
        Math.ceil(self.grid.scrollLeft + self.grid.clientWidth) >= self.grid.scrollWidth - 1;
    }
    this.grid.addEventListener('scroll', updateBtns, { passive: true });
    updateBtns();
  };

  /* ─── Popup table ─── */

  ProductCompare.prototype._buildTable = function () {
    var self = this;
    var products = [];
    if (this.mainProduct) products.push(this.mainProduct);
    this.selected.forEach(function (p) { products.push(p); });
    var cfg = this.cfg;

    var html = '<table class="pc-table"><thead><tr>';
    html += '<th class="pc-table__label" scope="col">Parameter</th>';
    products.forEach(function (p) {
      html += '<th class="pc-table__product-cell" scope="col">';
      if (p.img) {
        html += '<div class="pc-table__product-img-wrap">'
          + '<img class="pc-table__product-img" src="' + esc(p.img)
          + '" alt="' + esc(p.title) + '" width="80" height="80" loading="lazy"></div>';
      }
      if (p.reviewHtml) {
        html += '<div class="pc-table__product-reviews">' + p.reviewHtml + '</div>';
      }
      html += '<div class="pc-table__product-name">' + esc(p.title) + '</div></th>';
    });
    html += '</tr></thead><tbody>';

    cfg.attrLabels.forEach(function (label, idx) {
      if (!label) return;
      var allBlank = products.every(function (p) {
        return !p.attrs[idx] || !String(p.attrs[idx]).trim();
      });
      if (allBlank) return;
      html += '<tr><td class="pc-table__label" scope="row">' + esc(label) + '</td>';
      products.forEach(function (p) {
        html += '<td class="pc-table__value">' + esc(p.attrs[idx] || '—') + '</td>';
      });
      html += '</tr>';
    });

    html += '<tr class="pc-table__price-row"><td class="pc-table__label" scope="row">'
      + esc(cfg.priceLabel) + '</td>';
    products.forEach(function (p) {
      html += '<td class="pc-table__value">' + esc(p.price) + '</td>';
    });
    html += '</tr>';

    html += '<tr class="pc-table__cta-row"><td class="pc-table__label" scope="row">'
      + esc(cfg.ctaLabel) + '</td>';
    products.forEach(function (p) {
      html += '<td class="pc-table__value pc-table__cta" data-cta-pid="' + esc(p.pid) + '"></td>';
    });
    html += '</tr></tbody></table>';

    this.popupTableWrap.innerHTML = html;

    products.forEach(function (p) {
      var cell = self.popupTableWrap.querySelector('.pc-table__cta[data-cta-pid="' + p.pid + '"]');
      if (!cell) return;
      var card = (self.mainProductCard && String(self.mainProductCard.dataset.pid) === String(p.pid))
        ? self.mainProductCard
        : self.el.querySelector('.pc-card[data-pid="' + p.pid + '"]');
      var tpl = card && card.querySelector('.pc-btn-tpl');
      if (tpl && tpl.content) {
        cell.appendChild(tpl.content.cloneNode(true));
      } else {
        var a = document.createElement('a');
        a.href = p.url;
        a.className = 'btn';
        a.textContent = cfg.btnLabel;
        cell.appendChild(a);
      }
    });

    // Reset horizontal scroll, then wire up the desktop slider if needed
    this.popupTableWrap.scrollLeft = 0;
    this._setupPopupSlider(products.length);
  };

  /* ─── Popup column slider (desktop only, >3 products) ─── */

  ProductCompare.prototype._setupPopupSlider = function (productCount) {
    var self = this;
    var modal = this.popup.querySelector('.pc-popup__modal');
    var body  = this.popup.querySelector('.pc-popup__body');

    // ── Tear down previous slider state ──
    var existingNav = modal.querySelector('.pc-popup__slider-nav');
    if (existingNav) existingNav.parentNode.removeChild(existingNav);
    this.popup.classList.remove('pc-popup--slider-active');
    if (this._popupScrollHandler) {
      this.popupTableWrap.removeEventListener('scroll', this._popupScrollHandler);
      this._popupScrollHandler = null;
    }

    // Reset any inline widths from a previous slider run
    var table = this.popupTableWrap.querySelector('.pc-table');
    var productCells = Array.prototype.slice.call(
      this.popupTableWrap.querySelectorAll('th.pc-table__product-cell')
    );
    if (table) {
      table.style.removeProperty('width');
      table.style.removeProperty('min-width');
    }
    productCells.forEach(function (cell) {
      cell.style.removeProperty('width');
      cell.style.removeProperty('min-width');
    });

    // Slider only on desktop (≥750 px) with more than 3 products
    if (window.innerWidth < 750 || productCount <= 3) return;

    // ── STEP 1: Apply column widths FIRST so layout is correct before updateBtns fires ──
    var labelWidth = window.innerWidth >= 990 ? 140 : 120;
    var colWidth   = (window.innerWidth - labelWidth) / 3.5;

    if (table) {
      table.style.setProperty('width', 'auto', 'important');
      table.style.setProperty('min-width', '100%', 'important');
    }
    productCells.forEach(function (cell) {
      cell.style.setProperty('width', colWidth + 'px', 'important');
      cell.style.setProperty('min-width', colWidth + 'px', 'important');
    });

    this.popup.classList.add('pc-popup--slider-active');

    // ── STEP 2: Build the nav bar ──
    var nav = document.createElement('div');
    nav.className = 'pc-popup__slider-nav';

    var prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.className = 'pc-popup__slide-btn pc-popup__slide-btn--prev';
    prevBtn.setAttribute('aria-label', 'Previous products');
    prevBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 18 9 12 15 6"></polyline></svg>';
    prevBtn.disabled = true;

    var nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.className = 'pc-popup__slide-btn pc-popup__slide-btn--next';
    nextBtn.setAttribute('aria-label', 'Next products');
    nextBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"></polyline></svg>';

    nav.appendChild(prevBtn);
    nav.appendChild(nextBtn);

    // Insert nav between popup header and popup body
    modal.insertBefore(nav, body);

    // ── STEP 3: Bind scroll helpers ──
    function getColWidth() {
      var th = self.popupTableWrap.querySelector('th.pc-table__product-cell');
      return th ? th.offsetWidth : colWidth;
    }

    function updateBtns() {
      var wrap = self.popupTableWrap;
      prevBtn.disabled = wrap.scrollLeft <= 1;
      nextBtn.disabled = Math.ceil(wrap.scrollLeft + wrap.clientWidth) >= wrap.scrollWidth - 1;
    }

    prevBtn.addEventListener('click', function () {
      self.popupTableWrap.scrollBy({ left: -getColWidth(), behavior: 'smooth' });
    });
    nextBtn.addEventListener('click', function () {
      self.popupTableWrap.scrollBy({ left: getColWidth(), behavior: 'smooth' });
    });

    this._popupScrollHandler = updateBtns;
    this.popupTableWrap.addEventListener('scroll', updateBtns, { passive: true });

    // ── STEP 4: Update button states after layout reflow ──
    // Column widths were applied above so scrollWidth is correct by now
    setTimeout(updateBtns, 100);
  };

  /* ─── Distribute tbody row heights to fill the popup body in one viewport ─── */

  ProductCompare.prototype._distributeRowHeights = function () {
    var wrap = this.popupTableWrap;
    var table = wrap ? wrap.querySelector('.pc-table') : null;
    if (!table) return;

    var thead = table.querySelector('thead tr');
    var tbodyRows = Array.prototype.slice.call(table.querySelectorAll('tbody tr'));
    if (!tbodyRows.length) return;

    var availH = wrap.clientHeight;
    var theadH = thead ? thead.offsetHeight : 0;
    var remaining = availH - theadH;
    if (remaining <= 0) return;

    var rowH = Math.floor(remaining / tbodyRows.length);
    if (rowH < 24) return; // viewport too small — skip

    tbodyRows.forEach(function (row) {
      row.querySelectorAll('td').forEach(function (td) {
        var inner = document.createElement('div');
        inner.className = 'pc-cell-inner';
        inner.style.height = rowH + 'px';
        inner.style.overflow = 'hidden';
        inner.style.display = 'flex';
        inner.style.alignItems = 'center';
        inner.style.justifyContent = 'center';
        inner.style.textAlign = 'center';
        inner.style.padding = '0 14px';
        inner.style.boxSizing = 'border-box';
        while (td.firstChild) inner.appendChild(td.firstChild);
        td.style.setProperty('padding', '0', 'important');
        td.appendChild(inner);
      });
    });
  };

  ProductCompare.prototype._openPopup = function () {
    var self = this;
    this._lastFocused = document.activeElement;

    // Build the table first — it reads this.selected, so must happen before we clear it
    this._buildTable();

    // Clear all card selections and hide the bar immediately.
    // This ensures the cart drawer (and any other overlay) opens freely
    // without the compare bar blocking it or creating z-index conflicts.
    this.selected.forEach(function (data, pid) {
      var card = self.el.querySelector('.pc-card[data-pid="' + pid + '"]');
      if (card) self._deselect(pid, card);
    });
    this.selected.clear();
    this.bar.classList.remove('is-active');
    this._syncWidgets(false); // restore any widgets that were pushed behind the bar

    this.popup.classList.add('is-active');
    document.body.classList.add('pc-overflow-hidden');
    var close = this.popup.querySelector('.pc-popup__close');
    if (close) close.focus();

    this._popupKeyHandler = function (e) {
      if (e.key === 'Escape') self._closePopup();
    };
    document.addEventListener('keydown', this._popupKeyHandler);
  };

  ProductCompare.prototype._closePopup = function () {
    this.popup.classList.remove('is-active');
    document.body.classList.remove('pc-overflow-hidden');
    if (this._popupKeyHandler) {
      document.removeEventListener('keydown', this._popupKeyHandler);
      this._popupKeyHandler = null;
    }
    if (this._lastFocused && this._lastFocused.focus) this._lastFocused.focus();
  };

  ProductCompare.prototype._bindPopup = function () {
    var self = this;
    this.popupClose.addEventListener('click', function () { self._closePopup(); });
    this.popupBackdrop.addEventListener('click', function () { self._closePopup(); });

    // VIEW OPTIONS inside compare popup opens theme-modal at z-index 1500 —
    // behind our compare popup at max z-index (2147483647).
    // We cannot go higher than max, so the fix uses DOM paint order:
    // re-append #ThemeModal to body (making it the last child) and set the
    // same z-index — the later element in the DOM paints on top at equal z-index.
    this.popupTableWrap.addEventListener('click', function (e) {
      var modalBtn = e.target.closest('[data-modal-button]');
      if (!modalBtn) return;

      var themeModalEl = document.querySelector('#ThemeModal');
      if (!themeModalEl) return;

      themeModalEl.style.zIndex = '2147483647';
      document.body.appendChild(themeModalEl); // moves to last → paints above compare popup

      // Reset when quick-view closes (theme-modal removes body.theme-modal-open)
      var obs = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if (!document.body.classList.contains('theme-modal-open')) {
            themeModalEl.style.zIndex = '';
            obs.disconnect();
            break;
          }
        }
      });
      obs.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }, true); // capture phase — fires before theme-modal's own click handler
  };

  /* ─── AJAX Add-to-Cart ─── */

  ProductCompare.prototype._initCartAjax = function () {
    var self = this;
    // Document-level capture so it still fires after bar/popup are moved to body
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      if (!form.action || form.action.indexOf('/cart/add') === -1) return;
      if (form.closest('[data-modal-content]') || form.closest('theme-modal > template')) return;

      var inCard = form.closest('.pc-card');
      var inCta  = form.closest('.pc-table__cta');

      // Ensure the card/CTA belongs to this section's cards or popup
      if (inCard && !self.el.contains(inCard)) return;
      if (inCta  && !self.popup.contains(inCta))  return;
      if (!inCard && !inCta) return;

      e.preventDefault();
      e.stopPropagation();

      var btn = form.querySelector('[type="submit"]');
      var onSuccess = inCta ? function () { self._closePopup(); } : null;
      self._cartFetch(form, btn, onSuccess);
    }, true);
  };

  ProductCompare.prototype._cartFetch = function (form, btn, onSuccess) {
    var originalText = btn ? (btn.textContent || btn.innerText) : '';
    var originalDisabled = btn ? btn.disabled : false;

    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Adding…';
    }

    var formData = new FormData(form);
    // Ensure sections param is set so response includes rendered cart drawer HTML
    formData.set('sections', 'cart-drawer');
    formData.set('sections_url', window.location.pathname);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/javascript'
      },
      body: formData
    })
    .then(function (res) {
      if (!res.ok) return res.json().then(function (err) { throw err; });
      return res.json();
    })
    .then(function (data) {
      // Close popup before opening cart drawer
      if (onSuccess) onSuccess();

      if (btn) {
        btn.textContent = 'Added ✓';
        setTimeout(function () {
          btn.disabled = originalDisabled;
          btn.textContent = originalText;
        }, 2200);
      }

      // ── Update & open cart drawer via theme eventBus ──
      if (window.eventBus) {
        window.eventBus.emit('update:cart:drawer', data);
        window.eventBus.emit('open:cart:drawer', { scrollToTop: true });
      }

      // ── Fallback: Shopify section rendering to refresh cart count ──
      if (!window.eventBus) {
        fetch(window.Shopify && window.Shopify.routes
          ? window.Shopify.routes.root + 'cart.js'
          : '/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          // Update any cart count indicators
          document.querySelectorAll('[data-cart-count], .js-cart-count').forEach(function (el) {
            el.textContent = cart.item_count;
          });
        }).catch(function () {});
      }
    })
    .catch(function (err) {
      if (btn) {
        btn.disabled = originalDisabled;
        btn.textContent = originalText;
        // Brief error flash
        var prev = btn.textContent;
        btn.textContent = err && err.description ? err.description : 'Error – try again';
        setTimeout(function () { btn.textContent = originalText; }, 2500);
      }
    });
  };

  /* ─── Watch drawers — lower bar z-index when any theme drawer opens ───
     Cart drawer and similar panels (z-index 1501) must appear above the
     compare bar (z-index max). When any drawer's aria-hidden flips to false
     we push the bar behind. Restored when all drawers close again.          */
  ProductCompare.prototype._watchDrawers = function () {
    var self = this;
    var drawers = Array.prototype.slice.call(
      document.querySelectorAll('[data-drawer-position], cart-drawer, size-guide-drawer')
    );
    if (!drawers.length) return;

    function sync() {
      var anyOpen = drawers.some(function (d) {
        return d.getAttribute('aria-hidden') === 'false' ||
               d.hasAttribute('open') ||
               d.classList.contains('is-active');
      });
      // Push bar behind drawers when any is open; restore when all close
      self.bar.style.zIndex = anyOpen ? '0' : '';
    }

    drawers.forEach(function (drawer) {
      new MutationObserver(sync).observe(drawer, {
        attributes: true,
        attributeFilter: ['aria-hidden', 'open', 'class']
      });
    });
  };

  /* ─── Move bar/popup to body (avoids stacking-context clipping) ─── */

  ProductCompare.prototype._moveToBody = function () {
    var sectionEl = this.el;
    var cssVars = [
      '--pc-bar-bg', '--pc-bar-text', '--pc-bar-btn-bg', '--pc-bar-btn-text',
      '--pc-popup-header-bg', '--pc-popup-header-text', '--pc-popup-row-alt',
      '--pc-popup-label-bg', '--pc-accent', '--pc-price-color',
      '--pc-btn-bg', '--pc-btn-text', '--pc-btn-hover-bg', '--pc-btn-radius',
      '--pc-card-selected-border'
    ];
    function copyCssVars(el) {
      var style = window.getComputedStyle(sectionEl);
      cssVars.forEach(function (v) {
        var val = style.getPropertyValue(v).trim();
        if (val) el.style.setProperty(v, val);
      });
    }
    copyCssVars(this.bar);
    copyCssVars(this.popup);
    document.body.appendChild(this.bar);
    document.body.appendChild(this.popup);
  };

  /* ─── Auto-select current product page product ─── */

  ProductCompare.prototype._autoSelectCurrentProduct = function () {
    if (this.mainProduct) return; // handled via includeMainProduct, not as a visible card
    var currentPid = this.cfg.currentProductId;
    if (!currentPid) return;
    var pid = String(currentPid);
    var card = this.el.querySelector('.pc-card:not(.pc-card--main)[data-pid="' + pid + '"]');
    if (!card || this.selected.has(pid)) return;
    this._select(pid, card);
    this._updateBar();
  };

  /* ─── Init ─── */

  function initAll() {
    document.querySelectorAll('.pc-section[data-section-id]').forEach(function (el) {
      if (!el._pc) el._pc = new ProductCompare(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.pc-section[data-section-id]');
    if (el) { el._pc = null; el._pc = new ProductCompare(el); }
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var el = e.target.querySelector('.pc-section[data-section-id]');
    if (el && el._pc) {
      document.body.classList.remove('pc-overflow-hidden');
      var pc = el._pc;
      if (pc.bar && pc.bar.parentNode === document.body) document.body.removeChild(pc.bar);
      if (pc.popup && pc.popup.parentNode === document.body) document.body.removeChild(pc.popup);
    }
  });
})();
